import { render, staticRenderFns } from "./NoticeArea.vue?vue&type=template&id=4d2cba4a&"
import script from "./NoticeArea.vue?vue&type=script&lang=ts&"
export * from "./NoticeArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports